import View from './View';

export { getPinInputStyles } from '../PinInputModalContent';

export const useViewModel = (props) => props;

export default View;
